module.exports = __webpack_public_path__ + "static/media/headerLogo.c78cd99c.png";